import type { AvvirEvent } from "type_aliases";
import { OrganizationMember } from "../../models/domain/organization_member";

export type OrganizationMemberUpdatedEvent = AvvirEvent<typeof ORGANIZATION_MEMBER_UPDATED, {
  firebaseOrganizationId: string,
  member: OrganizationMember
}>

export const organizationMemberUpdated = (firebaseOrganizationId: string, member: OrganizationMember): OrganizationMemberUpdatedEvent => ({
  type: ORGANIZATION_MEMBER_UPDATED,
  payload: {
    firebaseOrganizationId,
    member
  }
});

export const ORGANIZATION_MEMBER_UPDATED = "organization_member_updated";
